import * as yup from 'yup';

export const eStatementPreferencesValidation = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter a valid email address.'),

  addressLine1: yup.string().required(),

  city: yup.string().required(),

  state: yup
    .string()
    .nullable()
    .required(),

  zipCode: yup.string().required(),
});
